import { Pagination } from "api/models/response/pagination";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { employeeBussiness } from "api/bussiness/employee/employee-bussiness";
import { GetEmployees } from "api/models/request/employee/employee";
import {
  Employee,
  IEmployeeProperties,
} from "mobx-stores/_models/employee/employee";
import { withSetPropAction } from "../_extension/with-set-props";
import { PaginationStore } from "./common/pagination-store";
export const EmployeeQueryParams = types
  .model({
    code: "",
    fullName: "",
    departmentTypeId: types.maybeNull(types.string),
    showInActive: false,
  })
  .actions(withSetPropAction);
export const EmployeeManagement = types
  .model({
    employees: types.optional(types.array(Employee), []),
    employeeDetail: types.maybeNull(Employee),
    pagination: types.optional(PaginationStore, {}),
    openNew: false,
    openEdit: false,
    openDelete: false,
    openUpdateLaborContract: false,
    openUpdateExtraInfo: false,
    queryParams: types.optional(EmployeeQueryParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getEmployees: flow(function* getEmployees(request?: GetEmployees) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            code: self.queryParams.code,
            fullName: self.queryParams.fullName,
            departmentTypeIds: self.queryParams.departmentTypeId || undefined,
            showInActive: self.queryParams.showInActive || false,
          };
        }

        const res = (yield employeeBussiness.getLists<GetEmployees>(
          request
        )) as Pagination<IEmployeeProperties>;
        self.setProp(
          "employees",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          }))
        );
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getEmployeeDetail: flow(function* getEmployeeDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield employeeBussiness.getById(
          id
        )) as IEmployeeProperties;
        self.setProp("employeeDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
